import styled from '@emotion/styled';
import Link from 'next/link';
import { Blog } from 'constant/type';

import { breakPoints } from 'constant/breakPoints';

export default function BlogRelated({
  relatedBlogs,
}: {
  relatedBlogs: Blog[];
}) {
  return (
    <Wrap>
      <div className="title2">Related Posts</div>
      <WrapContainer>
        {relatedBlogs.map((item, idx) => (
          <Item key={idx}>
            <div>
              <Link href={'/blog/' + item.slug}>
                <a>
                  <InvisibleTitle>{item.title}</InvisibleTitle>
                  <img
                    width="270"
                    height="152"
                    loading="lazy"
                    src={item.image.url}
                    alt="Spirit labs"
                  />
                </a>
              </Link>
            </div>
            <div>
              <div className="font-semibold typo1">{item.title}</div>
              <Link href={'/blog/' + item.slug}>
                <a>
                  Read more{' '}
                  <img
                    // width="160"
                    // height="90"
                    loading="lazy"
                    src="/images/icon/anchor-right.svg"
                    alt="Spirit labs"
                  />
                </a>
              </Link>
            </div>
          </Item>
        ))}
      </WrapContainer>
    </Wrap>
  );
}

const Wrap = styled.div`
  border-top: 8px solid #e8e8ea;
  padding: 32px 16px;
  position: sticky;
  top: 0;

  .title2 {
    color: #444052;
  }

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    border-top: none;
    max-width: 535px;
    padding-left: 0;
    padding-top: 0;

    .title2 {
      font-weight: 600;
      font-size: 32px;
    }
  }
`;

const WrapContainer = styled.div`
  margin-top: 12px;
`;

const InvisibleTitle = styled.h5`
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
  color: #fff;
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
`;

const Item = styled.div`
  width: 100%;
  max-width: 600px; // for ipad only
  display: flex;
  padding-bottom: 20px;
  margin-bottom: 20px;
  &:not(:last-of-type) {
    border-bottom: 1px solid #e8e8ea;
  }

  & > div:first-of-type {
    width: 144px;
    aspect-ratio: 16/9;
    border-radius: 4px;
    overflow: hidden;
    margin-right: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

    a {
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  & > div:last-of-type {
    /* padding-left: 16px; */
    flex: 1;

    a {
      color: #ca8be9;
      font-weight: 500;

      img {
        position: relative;
        top: 2px;
      }
    }
  }

  @media screen and (min-width: ${breakPoints.tabletM}px) {
    & > div:first-of-type {
      width: 192px;
      height: auto;
      aspect-ratio: 16/9;
    }
  }

  @media screen and (min-width: ${breakPoints.desktopS}px) {
    transition: all 0.2s ease-in-out;
    border-bottom: none !important;
    flex-direction: column;

    & > div:first-of-type {
      width: 100%;
      height: auto;
      aspect-ratio: 16/9;
      margin-right: unset;
      margin-bottom: 16px;
    }
    & > div:last-of-type {
      a {
        display: none;
      }
    }

    &:hover {
      transform: scale(1.03);
      background: #ffffff;
      box-shadow: 0px 8px 24px rgba(232, 232, 234, 0.6);
      z-index: 100;
    }
  }
`;
